import React from "react";
import { LazyLoadImage } from "react-lazy-load-image-component";
import LogoYellowDefault from "assets/icon_logo_yellow.png";
import LogoDefaultRectangle from "assets/img_default_rectangle.png";
import LogoDefaultSquare from "assets/img_default_square.png";
import LogoDefaultGgg from "assets/icon_logo_yellow.png";

const getDefaultLogo = (isPayment, isImageSquare, isRating) => {
  if (isPayment) return LogoYellowDefault;
  if (isImageSquare) return LogoDefaultSquare;
  if (isRating) return LogoDefaultGgg;
  return LogoDefaultRectangle;
};

const ImageComp = (props) => {
  const {
    src,
    alt = "image",
    className = "",
    width,
    height,
    style,
    referrerPolicy,
    isPayment = false,
    isImageSquare = false,
    isRating = false,
    ...restProps
  } = props;

  const defaultImage = getDefaultLogo(isPayment, isImageSquare, isRating);

  const handleError = (e) => {
    e.target.onerror = null;
    e.target.src = defaultImage;
  };

  return (
    <LazyLoadImage
      onError={handleError}
      {...restProps}
      className={className}
      src={src || defaultImage}
      alt={alt}
      width={width}
      height={height}
      style={style}
      referrerPolicy={referrerPolicy}
    />
  );
};

export default ImageComp;
